import React from "react";
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";

class PaymentRequestForm extends React.Component {
  render() {
    return this.props.canMakePayment ? (
      <PaymentRequestButtonElement
        className={`payment-request-btn ${this.props.isDisabled ? "loading-content" : ""}`}
        options={{
          paymentRequest: this.props.paymentRequest,
          style: {
            paymentRequestButton: {
              type: "donate",
              theme: "dark",
              height: "58px",
            },
          },
        }}
      />
    ) : null;
  }
}
export default PaymentRequestForm;
